import { DateTime } from 'luxon';
import { toLuxon } from '@app/helper';

export interface ChatListItemInterface {
  id: string;
  type: string;
  content: string;
  created: DateTime;
  createdTime: number;
}

export class ChatEntity implements ChatListItemInterface {
  id = '';
  type = '';
  content = '';
  created: DateTime;
  createdTime: number;

  constructor(data: any) {
    this.created = toLuxon(data.created) || DateTime.now();
    this.createdTime = this.created.toMillis();
  }

  get isHeader() {
    return this.type == 'header';
  }

  get isMessage() {
    return this.type == 'message';
  }
}
